export const RADIAL_PANEL_CLEARANCE = 0.04;
